import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AppConfig from '../AppConfig';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    apiToken: "",
    userId: "",
    error: "",
    pg: "",
    optionSelected: "",
    addBank: true,
    openModel: false,
    mobileOptionSelected: "PhonePe",
    loaderScreen: false,
    timeLeft: 300,
    webTimeLeft:300,
    openRpdModel: false,
    rpdError: "",
    rpdHit: false,
    webRpdHit:false,
    email: "",
    mobile: "",
    id: "",
    isFirstRender: true,
    qrLink:"",
    primaryChosen:false,
  },
  reducers: {
    loginSuccess: (state, action) => {
      console.log(`loginSuccess ${JSON.stringify(action.payload)}`);
      state.apiToken = action.payload.token;
      state.userId = action.payload.userId;
      state.pg = action.payload.pg;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.apiToken = null;
      state.userId = null;
      state.error = action.payload;
    },
    setFirstRender: (state) => {
      state.isFirstRender = false
    },
    setOptionSelect: (state, action) => {
      state.optionSelected = action.payload
      state.addBank = false
    },
    setAddBankToTrue: (state) => {
      state.addBank = true
      state.optionSelected = ""
      state.webRpdHit=false
      state.webTimeLeft=300
      state.primaryChosen=false
    },
    setOpenModelToTrue: (state) => {
      state.openModel = true
    },
    setOpenModelToFalse: (state) => {
      console.log("inside setOpenModelToFalse")
      state.openModel = false
    },

    setMobileOptionSelected: (state, action) => {
      state.mobileOptionSelected = action.payload
    },
    setLoaderScreenToTrue: (state,) => {
      state.loaderScreen = true
    },
    setLoaderScreenToFalse: (state,) => {
      state.loaderScreen = false
    },
    setTimeLeft: (state, action) => {
      state.timeLeft = Math.max(0, state.timeLeft - 1);
    },
    resetTimeLeft: (state) => {
      state.timeLeft = 300;
    },

    setWebTimeLeft: (state, action) => {
      state.webTimeLeft = Math.max(0, state.webTimeLeft - 1);
    },
    resetWebTimeLeft: (state) => {
      state.webTimeLeft = 300;
    },
    setRpdMsgModelToTrue: (state, action) => {
      state.openRpdModel = true
      state.rpdError = action?.payload
      state.id = ""
    },
    setRpdMsgModelToFalse: (state) => {
      state.openRpdModel = false
      state.loaderScreen = false
      state.openModel = true
      state.optionSelected = "RPD"
      state.mobileOptionSelected = ""
      state.rpdError = ""
    },
    setRpdSuccess: (state, action) => {
      state.loaderScreen = false
      state.mobileOptionSelected = ""
      state.rpdError = ""
      state.openModel = false
    },
    setRpdError: (state, action) => {
      state.rpdError = action.payload
    },
    setRpdHitToTrue: (state) => {
      state.rpdHit = true
    },
    setRpdHitToFalse: (state) => {
      state.rpdHit = false
    },
    setWebRpdHitToTrue:(state)=>{
      state.webRpdHit= true
    },
    setWebRpdHitToFalse: (state) => {
      state.webRpdHit = false
    },
    resetBankStates: (state) => {
      console.log("rreeeee")
      state.openRpdModel = false
      state.loaderScreen = false
      state.openModel = false
      state.mobileOptionSelected = "PhonePe"
      state.timeLeft = 300
      state.webTimeLeft=300
      state.rpdError = ""
      state.rpdHit = false
      state.webRpdHit=false
      state.openModel = false
      state.addBank = true
      state.qrLink=""
      state.primaryChosen=false
    },
    setEmailAndNum: (state, action) => {
      console.log("acctionn", action.payload)
      state.email = action.payload?.email
      state.mobile = action.payload?.mobile
    },
    setId: (state, action) => {
      state.id = action.payload
    },
    //added by dev-Ayush 22-01-2026
    reset: (state, action) => {
      state.apiToken = ""
      state.userId = ""
    },
    setQrLink:(state,action)=>{
         state.qrLink =action.payload
    },
    setPrimaryChosen:(state,action)=>{
      state.primaryChosen = action.payload
    }
    // registerSuccess: (state, action) => {
    //   state.apiToken = action.payload;
    //   state.error = null;
    // },
    // registerFailure: (state, action) => {
    //   state.apiToken = null;
    //   state.error = action.payload;
    // },
  },
  extraReducers: (builder) => {
    // builder.addCase(validateToken.pending, (state) => {
    //   // Add pending logic if needed
    // });
    // builder.addCase(validateToken.fulfilled, (state) => {
    //   // Add fulfilled logic if needed
    // });
    // builder.addCase(validateToken.rejected, (state) => {
    //   // Add rejected logic if needed
    // });
  },
});

// Thunk action to login token
export const loginToAuthControl = createAsyncThunk(
  'auth/loginToAuthControl',
  async (options, { dispatch }) => {
    try {
      const response = await fetch(AppConfig.api.AuthControl.loginToApiServer, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${options.authToken}`// symphony token 
        },
        body: JSON.stringify({
          userId: options.userId
        })
      });
      if (response.status === 200) {
        const data = await response.json();
        let responseData = {
          success: true
        };
        return responseData;
      } else {
        // If response status is not 200, token is invalid
        throw new Error('Invalid response status');
      }
    } catch (error) {
      dispatch(loginFailure('Error validating token')); // Dispatch loginFailure on error
      throw error;
    }
  }
);

// Thunk action to login token
export const validateToken = createAsyncThunk(
  'auth/validateToken',
  async (options, { dispatch }) => {
    try {
      const response = await fetch(AppConfig.api.Auth.validateToken, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${options.authToken}`// symphony token 
        },
        body: JSON.stringify({
          userId: options.userId,
          token: options.authToken
        })
      });
      if (response.status === 200) {
        const data = await response.json();
        let responseData = {
          success: true,
          token: data && data.data && data.data.token,
          userId: data && data.data && data.data.userId,
          pg: data && data.data && data.data.pg
        };
        return responseData
      } else {
        // If response status is not 200, token is invalid
        throw new Error('Invalid response status');
      }
    } catch (error) {
      dispatch(loginFailure('Error validating token')); // Dispatch loginFailure on error
      throw error;
    }
  }
);

// Thunk action to login token (nxt option) , dev-ayush 24-09-2025
export const validateToken_nxtOtp = createAsyncThunk(
  'auth/validate_nxtopt',
  async (options, { dispatch }) => {
    try {
      const response = await fetch(AppConfig.api.Auth.validateTokenNxtOpt, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${options.authToken}`// symphony token 
        },
        body: JSON.stringify({
          userId: options.userId,
          token: options.authToken
        })
      });
      if (response.status === 200) {
        const data = await response.json();
        let responseData = {
          success: true,
          token: data && data.data && data.data.token,
          userId: data && data.data && data.data.userId,
          pg: data && data.data && data.data.pg
        };
        return responseData
      } else {
        // If response status is not 200, token is invalid
        throw new Error('Invalid response status');
      }
    } catch (error) {
      dispatch(loginFailure('Error validating token')); // Dispatch loginFailure on error
      throw error;
    }
  }
);

export const { loginSuccess, loginFailure, registerSuccess, registerFailure, setOptionSelect, setAddBankToTrue, setOpenModelToTrue, setOpenModelToFalse, setMobileOptionSelected, setLoaderScreenToTrue, setLoaderScreenToFalse, resetTimeLeft, setTimeLeft, setRpdMsgModelToTrue, setRpdMsgModelToFalse, setRpdError, setRpdHitToTrue, setRpdHitToFalse, resetBankStates, setEmailAndNum, setId, setRpdSuccess, setFirstRender, reset, setQrLink, resetWebTimeLeft, setWebTimeLeft, setWebRpdHitToTrue, setWebRpdHitToFalse, setPrimaryChosen } = authSlice.actions;
export default authSlice.reducer;
